export default function InventoryCharacterIcon() {
  return (
    <div
      className="absolute w-full left-1/2 -translate-x-1/2 flex justify-center"
      style={{
        background: "radial-gradient(circle,#FF4E4E50 0%, transparent 30%)",
      }}
    >
      <img src="./svg/inventory/character.svg" alt="" className="w-[15.625rem] h-[16rem]" />
    </div>
  );
}
